import { Rutas } from '@/constants/rutas';
import PrediccionesFantasyIcon from '../../icons/predicciones-fantasy-icon';

export const NavigationPrediccionesFantasyItems = [
    {
        title: 'Jugar',
        shortTitle: 'Predict',
        path: Rutas.PREDICCIONES_FANTASY,
        id: 'predicciones-fantasy',
        icon: <PrediccionesFantasyIcon width={20} height={20} />,
    },
    {
        title: 'Reglas',
        shortTitle: 'Reglas',
        path: Rutas.PREDICCIONES_FANTASY_REGLAS,
    },
    {
        title: 'Ranking',
        shortTitle: 'Ranking',
        path: Rutas.PREDICCIONES_FANTASY_RANKING,
    },
];
